import { AxiosError } from 'axios'
import { computed, flow, makeObservable, observable } from 'mobx'

import { requestWrapper } from 'Shared/utils/network'

import { ALL_OPTION, STORE_UI } from 'Core/constants'
import { searchQueryConfig } from 'Core/constants/filters'
import { CoreUrlParams, SortingParams } from 'Core/interfaces'
import { TableStore } from 'Core/stores/tableStore/TableStore'
import { entityToLabelWithDashValue } from 'Core/utils'
import { getDefaultStoreArrayValue, storagePageSizeConstant } from 'Core/utils/storeHelpers'

import { UrlParams } from 'Portals/Customer/constants'
import { BiohazardousManifest } from 'Portals/Customer/entities'
import {
	getFilterConfig,
	getMainSearchConfig
} from 'Portals/Customer/Pages/BiohazardousManifest/TableList/Filters/utils/config'
import { BiohazardousManifestRepo } from 'Portals/Customer/repositories'
import { WastestreamRepo } from 'Portals/Customer/repositories'
import { RootStore } from 'Portals/Customer/stores'

const STORAGE_BIOHAZARDOUS_MANIFEST_PAGE_SIZE = storagePageSizeConstant('biohazardousManifest')

export class BiohazardousManifestTable extends TableStore<BiohazardousManifest.Basic> {
	@observable public accessor serviceSites = getDefaultStoreArrayValue<Entity>()

	constructor(private rootStore: RootStore) {
		super(STORAGE_BIOHAZARDOUS_MANIFEST_PAGE_SIZE)
	}

	@flow.bound
	*getItems(defaultSort?: SortingParams) {
		try {
			yield this.requestData({
				repository: BiohazardousManifestRepo.getList,
				defaultSort
			})
		} catch (error) {
			this.rootStore[STORE_UI].showErrorNotification(error as AxiosError)
		}
	}

	@flow.bound
	*retrieveServiceSites() {
		yield requestWrapper({
			field: this.serviceSites,
			repository: WastestreamRepo.retrieveWasteStreamServiceSites,
			repositoryParams: null
		})
	}

	@computed
	get serviceSiteOptions(): LabelValue[] {
		const formatStatuses = this.serviceSites.value.map((status) =>
			entityToLabelWithDashValue(status)
		)

		return [ALL_OPTION, ...formatStatuses]
	}

	initFromURLParams = (params: Record<string, string[]>) => {
		const searchKeys = [
			UrlParams.disposalFacility,
			UrlParams.document,
			CoreUrlParams.searchQuery
		]
		const filterKeys = [UrlParams.startDate, UrlParams.endDate, UrlParams.serviceSiteId]

		const mergedSearchConfig = {
			...getMainSearchConfig(),
			...searchQueryConfig
		}

		this.initSearchParamsFromUrl(params, searchKeys, mergedSearchConfig)
		this.initFilterParamsFromUrl(params, filterKeys, getFilterConfig())
	}

	retrieveFiltersData = () => {
		this.retrieveServiceSites()
	}

	clearFilterData = () => {
		this.resetTable()
		this.serviceSites = getDefaultStoreArrayValue<Entity>()
	}
}
